import { render, staticRenderFns } from "./EditParentCategory.vue?vue&type=template&id=5af314ae&"
import script from "./EditParentCategory.vue?vue&type=script&lang=js&"
export * from "./EditParentCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports